import { createFileRoute } from "@tanstack/react-router";
import { LiveAdminPage } from "@/components/shared/LiveAdminPage";
export const Route = createFileRoute("/admin.finance")({ component: Page });
function Page() {
  return (
    <LiveAdminPage
      title="Finance"
      description="Payment ledger."
      table="payments"
      columns={[
        { key: "provider", label: "Provider" },
        { key: "amount", label: "Amount" },
        { key: "status", label: "Status" },
        { key: "provider_payment_id", label: "Reference" },
      ]}
    />
  );
}